module.exports = __webpack_public_path__ + "1d75b0b2863b392a80345d71b1372153.png";